import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "success-oval",
  "use": "success-oval-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"success-oval\">\n<circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#80BA40\" />\n<path d=\"M4.5 9.00005L7.77273 12.6L13.5 6.30005\" stroke=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol